import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardPageComponent } from './dashboard/containers/dashboard-page.component';


const routes: Routes = [
  {
    path: 'account', pathMatch: 'prefix',
    children: [
      {path: 'dashboard', component: DashboardPageComponent},
    ],
  },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/account/account-routing.module.ts